import { Component, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { ClientService } from 'src/app/shared/service/disbursment/client.service';

@Component({
  selector: 'app-others-dialog',
  templateUrl: './others-dialog.component.html',
  styleUrls: ['./others-dialog.component.scss'],
})
export class OthersDialogComponent {
  othersForm: FormGroup;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<OthersDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private clientService: ClientService,
    private snackBar: ToastrService,
  ) {
    this.othersForm = this.fb.group({});

    this.buildForm();
  }

  buildForm(): void {
    switch (this.data.type) {
      case 'vessel':
        this.othersForm = this.fb.group({
          vessel_name: ['', Validators.required],
          imo_number: [
            '',
            [Validators.required, Validators.pattern(/^[0-9]+$/)],
           
          ],
           head_owners_name:['']
        });
        break;

      case 'port':
        this.othersForm = this.fb.group({
          port_name: ['', Validators.required],
          country_name:['',Validators.required]
        });
        break;

      case 'cargo':
        this.othersForm = this.fb.group({
          cargo: ['', Validators.required],
        });
        break;

      case 'portagent':
        this.othersForm = this.fb.group({
          portagent_name: ['', Validators.required],
          email: ['', [Validators.required, Validators.email]],
        });
        break;

      case 'purpose':
        this.othersForm = this.fb.group({
          purpose: ['', Validators.required],
        });
        break;
    }
  }

  get title(): string {
    switch (this.data.type) {
      case 'vessel':
        return 'Add Other Vessel';

      case 'port':
        return 'Add Other Port';

      case 'cargo':
        return 'Add Other Cargo';

      case 'portagent':
        return 'Add Other Port Agent';

      case 'purpose':
        return 'Add Other Purpose';

      default:
        return 'Add Other';
    }
  }

  save(): void {
    if (this.othersForm.invalid) {
      this.othersForm.markAllAsTouched();
      return;
    }

    const formValue = this.othersForm.getRawValue();

    const payload = this.buildPayload(formValue);

    console.log('Notify Missing Entities Payload:', payload);

    this.clientService.notifyMissingEntities(payload).subscribe({
      next: (response) => {
        console.log('Missing entity notification sent:', response);
        this.snackBar.success('Request submitted successfully');
        this.dialogRef.close({
          success: true,
          type: this.data.type,
          value: formValue,
          response: response,
        });
      },

      error: (error) => {
        console.error('Notify missing entities failed:', error);
      },
    });
  }
  private buildPayload(formValue: any): any {
    const payload: any = {
      client_name: this.data.client_name || '',
      user_email: this.data.user_email || '',

      vessel: null,
      port: null,
      port_agent: null,
      cargo: null,
      purpose: null,

      notes: 'Please add these entities to master system.',
    };

    switch (this.data.type) {
      case 'vessel':
        payload.vessel = {
          name: formValue.vessel_name,
          imo_number: formValue.imo_number,
        };
        break;

      case 'port':
        payload.port = {
          name: formValue.port_name,
          country: this.data.country || '',
        };
        break;

      case 'cargo':
        payload.cargo = {
          name: formValue.cargo,
        };
        break;

      case 'portagent':
        payload.port_agent = {
          name: formValue.portagent_name,
          email: formValue.email,
        };
        break;

      case 'purpose':
        payload.purpose = {
          name: formValue.purpose,
        };
        break;
    }

    return payload;
  }
  cancel(): void {
    this.dialogRef.close();
  }
}
